import React, { useState } from "react";
import TopNav from "../../../Components/TopNav";
import Navbar from "../../../Components/Navbar";
import DropdownNav from "../../../Components/DropdownNav";
import "../About_Pages/about.css";
import Footer from "../../../Components/Footer";
import { Link } from "react-router-dom";
import Example from "../../../Components/Example";

const Departments = () => {
  return (
    <div>
      <Example />
      <div className="navbar-area">
        <div className="dept-init-image">
          <div className="image-cover"></div>
        </div>
      </div>

      <div className="Measi-details">
        <div className="measi-header">
          <h2>Schools of Excellence</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat
            quidem omnis quasi debitis assumenda voluptatem in, beatae dolorem
            obcaecati pariatur earum fuga cupiditate, voluptate ipsa quae
            laborum soluta sunt incidunt.
          </p>
          <br></br>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Id libero
            ad commodi vero aspernatur sit nulla, quidem aperiam voluptatem
            eveniet debitis odio cupiditate voluptate necessitatibus adipisci
            pariatur hic distinctio ipsum iusto fugiat harum totam eum illo!
            Esse quam ut eius totam, ex alias eos atque, amet dolore aperiam
            repellat eveniet cum distinctio. Quam aut ea, ut dignissimos ad
            accusamus esse commodi hic quisquam veniam a voluptatum aliquam et
            tempora eveniet. Sit beatae error placeat explicabo, eaque odit
            nostrum, iusto reprehenderit expedita dolore cumque? Labore sit
            soluta similique temporibus ab consectetur natus cupiditate cum
            architecto voluptatem excepturi aperiam, animi quos eum, tempore
            error debitis alias suscipit. Maxime quod sint quo cum doloremque?
            Atque, nesciunt pariatur quam labore repellendus ab a, mollitia
            reiciendis eum rerum distinctio tempore quaerat velit amet officia
            similique blanditiis, fuga magni ducimus eveniet. Similique quos
            ratione illum. Necessitatibus non obcaecati nulla provident eos quos
            eveniet totam, recusandae sint.
          </p>

          <br></br>

          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam,
            distinctio maiores doloremque debitis voluptatem iste inventore ipsa
            deleniti eos eaque nobis repudiandae veniam nulla dignissimos? Omnis
            nam suscipit error laboriosam, dolore rerum neque voluptate
            pariatur. Cumque minima, voluptas at asperiores nesciunt delectus
            quod, necessitatibus velit aspernatur voluptatibus laborum doloribus
            vel temporibus consequuntur voluptate incidunt, illum nam inventore
            iusto! Repellendus nesciunt id est impedit amet vitae, quidem
            aliquam iure ipsa praesentium illum nisi esse distinctio deleniti
            tempora harum eligendi veritatis laboriosam aperiam molestiae ex!
            Maiores dignissimos alias quae eveniet ex, voluptatem excepturi
            exercitationem deserunt laborum cum aut perspiciatis amet nemo
            voluptatibus.
          </p>

          <br></br>
        </div>

        <div className="dept-details">
          <div className="flex flex-row items-center justify-center flex-wrap">
            <div className="dept-name">
              <img
                src="https://imgs.search.brave.com/TUMHumF_t4JN6x6ixQ3uv7YbdMXeIVElu3JvhHaw_lM/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTc1/NDE2Njg2L3Bob3Rv/L2xhbmd1YWdlLmpw/Zz9zPTYxMng2MTIm/dz0wJms9MjAmYz1N/d1J0cTVRUFZlT3ZH/S0tpUGtzVXFkdHRx/NHVrZG4tQ2pfMjBQ/UGdUQWpJPQ"
                className="dept-images"
              />
              <h3>School of Languages</h3>
              <Link to={"/English"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>

            <div className="dept-name">
              <img
                src="https://lupsscience.weebly.com/uploads/1/3/9/3/13935343/published/screen-shot-2020-08-03-at-22-21-26.png?1596507724"
                className="dept-images"
              />
              <h3>School of Sciences</h3>
              <Link to={"/Tamil"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>

            <div className="dept-name">
              <img
                src="https://snow.edu/academics/humanities/images/Humanities-Wall-Graphic-small.png"
                className="dept-images"
              />
              <h3>School of Humanities</h3>
              <Link to={"/Arabic"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>

            <div className="dept-name">
              <img
                src="https://lh3.googleusercontent.com/proxy/bkCNtKroLHPozwe9IKI8fzmjExdfsc6RMfNl0HtrMGuBZjKQD-E_Z_5HdABHhQRfoBC7xrYYg7GT9Ot1PnHS8QmLPw"
                className="dept-images"
              />
              <h3>School of Commerce</h3>
              <Link to={"/Urdu"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>

            <div className="dept-name">
              <img
                src="https://cdn.dribbble.com/users/363611/screenshots/20577363/media/118ee4028dd2bfe2318f7b35cc6b45de.jpg?resize=400x0"
                className="dept-images"
              />
              <h3>School of Management</h3>
              <Link to={"/Hindi"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>

            <div className="dept-name">
              <img
                src="https://thumbs.dreamstime.com/b/concept-thinking-background-brain-cpu-mind-series-technology-symbols-subject-computer-science-artificial-concept-117062986.jpg"
                className="dept-images"
              />
              <h3>School of Computational</h3>
              <Link to={"/French"} className="move-btn">
                <h3 className="dept-open-btn">More Details ➡</h3>
              </Link>
            </div>
          </div>

          {/* <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/h1.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Historical Studies</h3>
            <Link to={"/Historical Studies"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/e1.jpeg' className='dept-images' />
            <h3>Department Of Economics</h3>
            <Link to={"/Economics"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/s1.jpeg' className='dept-images' />
            <h3>Department Of Sociology</h3>
            <Link to={"/Sociology"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/co.png' className='dept-images' />
            <h3>Department Of Commerce</h3>
            <Link to={"/Commerce"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/corp.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Corporate Secretaryship</h3>
            <Link to={"/Corporate Secretaryship"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/m4.jpeg' className='dept-images' />
            <h3>Department Of Mathematics</h3>
            <Link to={"/Mathematics"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/p3.jpeg' className='dept-images' />
            <h3>Department Of Physics</h3>
            <Link to={"/Physics"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/ch.jpeg' className='dept-images' />
            <h3>Department Of Chemistry</h3>
            <Link to={"/Chemistry"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/pl.jpeg' className='dept-images' />
            <h3>Department Of Botany</h3>
            <Link to={"/Botany"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/z5.jpeg' className='dept-images' />
            <h3>Department Of Zoology</h3>
            <Link to={"/Zoology"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/c1.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Computer Science</h3>
            <Link to={"/Computer Science"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/csa1.jpg' className='dept-images' />
            <h3>Department Of <br></br> Computer Applications</h3>
            <Link to={"/Computer Applications"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/it1.jpg' className='dept-images' />
            <h3>Department Of <br></br> Information Systems <br></br> Management</h3>
            <Link to={"/Information Systems Management"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/businessadminimage.jpg' className='dept-images' />
            <h3>Department Of <br></br> Business Administration</h3>
            <Link to={"/Business Administration"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/b1.jpg' className='dept-images' />
            <h3>Department Of <br></br> Bank Management</h3>
            <Link to={"/Bank Management"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/pl.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Biotechnology</h3>
            <Link to={"/Biotechnology"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/it2.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Information Technology</h3>
            <Link to={"/Information Technology"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/acc.png' className='dept-images' />
            <h3>Department Of <br></br> Accounting & Finance</h3>
            <Link to={"/Accounting & Finance"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/criminology.jpg' className='dept-images' />
            <h3>Department Of <br></br> Criminology & Police <br></br> Administration</h3>
            <Link to={"/Criminology & Police Administration"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/defence.jpg' className='dept-images' />
            <h3>Department Of <br></br> Defence & Strategic <br></br> Studies</h3>
            <Link to={"/Defence & Strategic Studies"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/electronic-media.jpg' className='dept-images' />
            <h3>Department Of <br></br> Electronic Media</h3>
            <Link to={"/Electronic Media"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/professional.jpeg' className='dept-images' />
            <h3>Department Of <br></br> Professional Accounting</h3>
            <Link to={"/Professional Accounting"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/Artificial-Intelligence1.jpg' className='dept-images' />
            <h3>Department Of <br></br> Artificial Intelligence</h3>
            <Link to={"/Artificial Intelligence"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/data-science.jpg' className='dept-images' />
            <h3>Department Of <br></br> Data Science</h3>
            <Link to={"/Data Science"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/sports.png' className='dept-images' />
            <h3>Department Of <br></br> Physical Education</h3>
            <Link to={"/Dept-PE"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div>


          <div className='dept-name'>
            <img src='https://thenewcollege.edu.in/images/IMG_1524.jpg' className='dept-images' />
            <h3>Details Of Library</h3>
            <Link to={"/ShiftI-Library"} className='move-btn'>
              <h3 className='dept-open-btn'>More Details ➡</h3>
            </Link>
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Departments;
